<template>
    <div v-if="!loading">
        <div layout="column" class="pa-3 pt1-pc pa1-mobile bg-white">
            <div class="backlink grey--text">
                <a layout="row" layout-align="start center" @click="$router.push({name: 'admin-schools-index'})"><v-icon class="mr-1" color="grey">mdi-chevron-left</v-icon>{{$t('schools.back')}}</a>
            </div>
            <div layout="row" layout-align="start center" class="headline font-weight-bold mt-2">{{school.name}}
                <v-chip v-if="!school.is_enabled" class="ml-2" color="error" text-color="white" small>
                    {{$t('_.disabled_f')}}
                </v-chip>
                <span flex></span>
                <v-btn :title="$t('_.edit')" class="mx-0 ma0-mobile" icon :to="{name: 'admin-schools-edit', params: {id: school.id}}"><v-icon color="secondary">mdi-pencil</v-icon></v-btn>
                <v-btn :title="school.is_enabled ? $t('_.disable') : $t('_.enable')" class="mx-0 ma0-mobile" icon @click="toggle">
                    <v-icon color="secondary">{{ school.is_enabled ? 'mdi-lock-outline': 'mdi-lock-open-outline' }}</v-icon>
                </v-btn>
                <v-btn :disabled="!school.can_delete" :title="$t('_.delete')" class="mx-0 ma0-mobile" icon @click="deleteDialog = true">
                    <v-icon color="error">mdi mdi-delete</v-icon>
                </v-btn>
            </div>

            <div layout="row" layout-align="start center" layout-wrap class="mt-3">
                <span @click.prevent="$router.push({name: 'admin-schools-show-info'})" class="clickable" :class="{'active-param' : $route.name.indexOf('admin-schools-show-info') == 0}">{{ $t('schools.tab_info') }}</span>
                <span class="grey--text ml-2 mr-2">|</span>
                <span @click.prevent="$router.push({name: 'admin-schools-show-representatives'})" class="clickable" :class="{'active-param' : $route.name.indexOf('admin-schools-show-representatives') == 0}">{{ $t('representatives.representatives') }}</span>
                <span flex></span>
                <div layout="row" layout-align="start center" v-if="!school.nb_representatives">
                    <v-icon color="warning" :title="$t('schools.no_rep_info')" class="mr1-pc">mdi-alert</v-icon>
                    <span class="hidden-sm-and-down">{{$t('schools.no_rep_info')}}</span>
                </div>
            </div>
        </div>

        <router-view name="panel" class="mt10-pc mt2-mobile" :school="school" @updated="fetch"></router-view>
        <v-dialog
          v-model="deleteDialog"
          max-width="300"
        >
          <v-card>
            <v-card-title class="title">{{$t('schools.delete')}}</v-card-title>
            <v-card-text>
              {{$t('schools.delete_details')}}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="secondary"
                flat="flat"
                @click="deleteDialog = false"
              >
                {{$t('_.cancel')}}
              </v-btn>
              <v-btn
                color="error"
                depressed
                @click="deleteDialog = false; deleteSchool()"
              >
                {{$t('_.delete')}}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import Schools from '@/api/schools'

    export default {
        data () {
            return {
                school: {
                    city: {}
                },
                deleteDialog: false,
                loading: true
            }
        },
        mounted () {
            this.fetch()
        },
        methods: {
            deleteSchool () {
              this.loading = true
              Schools.delete(this.school.id).then(
                () => {
                  this.loading = false
                  this.$snotify.success(this.$t("schools.removed"))
                  this.$router.push({ name: 'admin-schools-index' })
                },
                () => {
                  this.loading = false
                }
              )
            },
            fetch () {
                Schools.get(this.$route.params.id).then(res => {
                    this.school = res.data;
                    this.loading = false;
                })
            },
            toggle () {
                if (this.school.is_enabled) {
                    Schools.disable(this.school.id).then(() => {
                        this.school.is_enabled = 0;
                        this.$snotify.success(this.$t('schools.disable'))
                    })
                } else {
                    Schools.enable(this.school.id).then(() => {
                        this.school.is_enabled = 1;
                        this.$snotify.success(this.$t('schools.enable'))
                    })
                }
            },
        },
        computed: {

        }
    }
</script>
<style scoped>
.active-param {
  font-weight: bold;
  color: #2e3b7f;
}
</style>
